import i18n from '@/utils/i18n';
import Cookies from 'js-cookie';
import { getLehuiPayWay } from '@/api/user';
import { getBaseInfo, fetchSystemTime, getDefaultLeaveTime } from '@/api/systemSet';
import { fetchGrayHotelist } from '@/api/nightTrial.js';
/**
 * 配置
 * url   匹配路由
 * headerBgColor   顶部菜单栏颜色
 * headerColor    顶部菜单栏文字颜色
 * loginBgImg    登陆页背景图片
 * loginBtnColor   登陆按钮颜色
 * logo   顶部菜单栏logo地址
 * loginPageLogo   登陆页logo地址
 * loginPageLogoHeight   登陆页logo高度
 * loginPageLogoMarginTop   登陆页logo距离顶部高度
 * loginPageLogoNameDisplay   登陆页名称是否显示
 * title   页面标题
 */
const domainNameStyleList = [
  {
    url: 'pengyou',
    // url: 'localhost',
    headerBgColor: '#5DBE38',
    headerColor: '#ffffff',
    loginBgImg: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/pengyou.city/pengyouCity.jpg',
    loginBtnColor: '#5DBE38',
    logo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/pengyou.city/pengyouCityLogo.jpg',
    loginPageLogo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/pengyou.city/pengyouCityLogo.jpg',
  },
  {
    url: 'fmm',
    // url: 'loca',
    logo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/fmm/logo.png',
    loginPageLogo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/fmm/logo.png',
  },
  {
    url: 'wlj',
    // url: 'localhost',
    loginBgImg: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/wlj/loginBg.png',
    logo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/wlj/logo.png',
    loginPageLogo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/wlj/loginPageLogo.png',
    loginPageLogoHeight: '230px',
    loginPageLogoMarginTop: '25px',
    loginPageLogoNameDisplay: 'none',
  },
  {
    url: 'jjsef',
    // url: 'localhost',
    loginBgImg: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/jjsef/loginBg.jpg',
    logo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/jjsef/homeLogo.png',
    loginPageLogo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/jjsef/logo.png',
    loginPageLogoHeight: '80px',
    loginPageLogoMarginTop: '90px',
  },
  {
    url: 'yuanxusoft',
    // url: 'localhost',
    loginBgImg: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/yuanxusoft/loginBg.png',
    logo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/yuanxusoft/logo.png',
    loginPageLogo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/yuanxusoft/loginPageLogo.png',
    loginPageLogoHeight: '230px',
    loginPageLogoMarginTop: '25px',
    loginPageLogoNameDisplay: 'none',
    title: '源旭软件',
    favicon: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/yuanxusoft/favicon.ico',
    customHelpPhones: ['15937176446', '15038237136', '15515715879', '0371-86055500'],
    hideHelpOperator: true,
    hideAppShopEntry: true,
    miniProgramTitle: '源旭小程序',
    miniProgramImage: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/yuanxusoft/miniProgram.jpg',
    hiddenSidebarMenuUrls: ['/help/renew', '/sell/newhelp', '/help/feedback', '/help/faq'],
    hideHomePageLogUpdate: true,
    hideHomePageBanner: true,
    hiddenHardwareDeviceTypes: ['priceBrand'],
  },
  {
    url: 'crawlersmart',
    // url: 'localhost',
    logo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/crawlersmart/homeLogo.png',
    loginPageLogo: 'https://crm-1258682338.cos.ap-beijing.myqcloud.com/pms/custom-skin/crawlersmart/homeLogo.png',
    loginPageLogoHeight: '80px',
    loginPageLogoMarginTop: '90px',
  },
];

function setFavicon(favicon) {
  if (!favicon) return;
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = favicon;
}

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
  },
  device: 'desktop',
  linkRoomInfo: {},
  roomOrderStatusList: [],
  socketMessage: null,
  isNeedRefreshBusinessDay: false,
  lehuiPayWay: undefined,
  baseInfoSettings: null,
  isNightAuditGrayEnv: false, // 是否是夜审灰度环境
  printLoading: false,
  isHideNavHeader: true,
  isDisplayLeftMenu: true,
  notificationDisplay: false, // 是否显示通知
  language: Cookies.get('language') || 'zh-CN', // 新增语言状态（持久化到Cookies）
  systemMessage: 0,
  messageNotificationDisplay: false,
  // 是否需要刷新底部数据统计
  isNeedRefreshStatistics: false,
  aiNoticeUnread: 0,
  aiFloatSuppressors: {},
  currentColorLogo: {},
};

const mutations = {
  // 控制是否显示banner、快捷入口、消息通知
  SET_NAV_HEADER(state, s) {
    state.isHideNavHeader = s;
  },
  SET_NOTIFICATION_DISPLAY(state) {
    state.notificationDisplay = !state.notificationDisplay;
  },
  SET_AI_NOTICE_UNREAD(state, s) {
    state.aiNoticeUnread = s;
  },
  // 高优先级全局消息浮层展示期间，暂时隐藏 AI 悬浮入口。
  SET_AI_FLOAT_SUPPRESSOR(state, { name, active }) {
    if (!name) {
      return;
    }
    const suppressors = { ...state.aiFloatSuppressors };
    if (active) {
      suppressors[name] = true;
    } else {
      delete suppressors[name];
    }
    state.aiFloatSuppressors = suppressors;
  },
  // 打印的loading
  SET_LOADING(state, s) {
    state.printLoading = s;
  },
  SET_NIGHT_AUDIT_ENV(state, s) {
    state.isNightAuditGrayEnv = s;
  },
  SET_REFRESH(state, s) {
    state.isNeedRefreshBusinessDay = s;
  },
  SET_SOCKET_MSG(state, msg) {
    state.socketMessage = msg;
  },
  SET_LINK_ROOM_INFO(state, info) {
    state.linkRoomInfo = info;
  },
  SET_ROOM_ORDER_STATUS_LIST(state, list) {
    state.roomOrderStatusList = list;
  },
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_BASE_SETTING(state, info) {
    state.baseInfoSettings = info;
  },
  //判断左侧菜单是否显示
  Set_is_Display_Left_Menu(state, info) {
    state.isDisplayLeftMenu = info;
  },
  // 系统消息数量
  SET_SYSTEM_MESSAGE(state, s) {
    state.systemMessage = s;
  },
  // 新增语言切换mutation
  SET_LANGUAGE(state, language) {
    state.language = language;
    Cookies.set('language', language);
  },

  SET_MESSAGE_NOTIFICATION_DISPLAY(state, info) {
    state.messageNotificationDisplay = info;
  },
  // 是否需要刷新底部数据统计
  SET_REFRESH_STATISTICS(state) {
    state.isNeedRefreshStatistics = !state.isNeedRefreshStatistics;
  },
  // 当前域名的logo和背景图片颜色
  SET_CURRENT_COLOR_LOGO(state, logo) {
    if (state.currentColorLogo.url) return;
    const currentDomain = window.location.hostname;
    const domainStyle = domainNameStyleList.find((item) => currentDomain.includes(item.url));
    if (domainStyle) {
      state.currentColorLogo = domainStyle;
      setFavicon(domainStyle.favicon);
    }
    state.currentColorLogo.url = currentDomain;
  },
};

const actions = {
  fetchCurrentTime({ state }) {
    return new Promise((resolve) => {
      fetchSystemTime().then((res) => {
        if (res.code === '0') {
          resolve({
            date: res.data,
          });
        }
      });
    });
  },
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  },
  // 消息通知是否显示
  fetchLehuiPayWay() {
    return new Promise((resolve) => {
      getLehuiPayWay().then((res) => {
        if (res.code === '0') {
          const pay = res.data.payType.find((item) => !item.checked);
          resolve(pay);
        }
      });
    });
  },
  async getBaseInfoSetting({ commit, state }, force) {
    if (force || !state.baseInfoSettings) {
      await getBaseInfo()
        .then((res) => {
          if (res.code === '0') {
            commit('SET_BASE_SETTING', res.data);
          }
        })
        .catch(() => { });
    }
    return state.baseInfoSettings;
  },
  async fetchGrayHotelist({ commit, state, rootState }) {
    await fetchGrayHotelist().then((res) => {
      if (res.code === '0') {
        // 业务标签：1全部新夜审 2全部老夜审 3部分新夜审
        const { label, hotelCodes } = res.data;
        if (label === 1) {
          commit('SET_NIGHT_AUDIT_ENV', false);
        } else if (label === 2) {
          commit('SET_NIGHT_AUDIT_ENV', true);
        } else {
          let isNew = true;
          const currentHotelCode = rootState.user.hotelCode;
          if (hotelCodes.includes(currentHotelCode)) {
            isNew = false;
          }
          commit('SET_NIGHT_AUDIT_ENV', isNew);
        }
      }
    });
  },
  getDefaultLeaveTime() {
    return new Promise((resolve) => {
      getDefaultLeaveTime()
        .then((res) => {
          if (res.code === '0') {
            resolve((res.data && res.data.latestDepartureTime) || '12:00');
          }
        })
        .catch(() => {
          resolve('12:00');
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
